import { Component, createResource, For, Show } from "solid-js";
import { useParams } from "@solidjs/router";
import { api } from "../auth";

const RaceCard: Component = () => {
  const params = useParams<{ raceId: string }>();
  const [race] = createResource(
    () => params.raceId,
    (id) => api<any>(`/api/races/${id}`),
  );
  const [odds] = createResource(
    () => params.raceId,
    (id) => api<any>(`/api/odds/${id}`).catch(() => ({ snapshots: [] })),
  );

  return (
    <Show when={race() && !race.loading} fallback={<p>Loading race...</p>}>
      {(() => {
        const r = race()!;
        return (
          <>
            <h1>{r.track?.track_name ?? r.track_id} <span class="badge">R{r.race_no ?? "?"}</span></h1>
            <div class="grid-3">
              <div class="stat"><div class="l">Date</div><div class="v">{r.date ?? "?"}</div></div>
              <div class="stat"><div class="l">Distance</div><div class="v">{r.distance_m ? `${r.distance_m}m` : "?"}</div></div>
              <div class="stat"><div class="l">Going</div><div class="v">{r.going ?? "?"}</div></div>
              <div class="stat"><div class="l">Field</div><div class="v">{r.field_size ?? "?"}</div></div>
              <div class="stat"><div class="l">Time</div><div class="v">{r.race_time_sec ? `${r.race_time_sec.toFixed(2)}s` : "?"}</div></div>
              <div class="stat"><div class="l">Source</div><div class="v">{r.source}</div></div>
            </div>

            <h2>Runners</h2>
            <div class="card" style="padding: 0;">
              <table>
                <thead>
                  <tr>
                    <th>Pos</th><th>Horse</th><th>Post</th><th>Wt</th>
                    <th>Jockey</th><th>LBW</th><th>Win div</th><th>Time proxy</th>
                    <th>Win probability</th><th>Edge</th>
                  </tr>
                </thead>
                <tbody>
                  <For each={r.runners}>
                    {(run: any) => (
                      <tr>
                        <td class={run.finish_pos === 1 ? "pos-1" : run.finish_pos === 2 ? "pos-2" : ""}>
                          {run.finish_pos ?? "—"}
                        </td>
                        <td>{run.horse_name ?? run.horse_id}</td>
                        <td>{run.post ?? "—"}</td>
                        <td>{run.weight_kg ? `${run.weight_kg}kg` : "—"}</td>
                        <td>{run.jockey}</td>
                        <td>{run.lengths_behind ?? "—"}</td>
                        <td>{run.win_div?.toFixed(2) ?? "—"}</td>
                        <td>{run.norm_time?.toFixed(1) ?? "—"}</td>
                        <td>{run.prediction?.prob_comb != null ? `${(run.prediction.prob_comb * 100).toFixed(1)}%` : "Pending model"}</td>
                        <td>
                          <Show when={run.prediction?.edge != null} fallback={<span class="muted">—</span>}>
                            <span class={run.prediction.edge > 0.1 ? "pos-1" : ""}>
                              {((run.prediction.edge as number) * 100).toFixed(1)}%
                            </span>
                          </Show>
                        </td>
                      </tr>
                    )}
                  </For>
                </tbody>
              </table>
            </div>

            <h2>Odds history <span class="muted">({odds()?.snapshots?.length ?? 0} snapshots)</span></h2>
            <Show when={odds()?.snapshots?.length} fallback={<p class="muted">No verified market odds available yet. Probabilities use horse history until a complete market is available.</p>}>
              <div class="card" style="padding: 0;">
                <table>
                  <thead>
                    <tr><th>Horse</th><th>Source</th><th>Market</th><th>Decimal</th><th>Implied %</th><th>Captured</th></tr>
                  </thead>
                  <tbody>
                    <For each={odds()!.snapshots}>
                      {(o: any) => (
                        <tr>
                          <td>{o.horse_id}</td>
                          <td><span class="badge">{o.source}</span></td>
                          <td>{o.market}</td>
                          <td>{o.decimal_odds?.toFixed(2)}</td>
                          <td>{o.implied_prob ? `${(o.implied_prob * 100).toFixed(1)}%` : "—"}</td>
                          <td class="muted">{o.captured_at}</td>
                        </tr>
                      )}
                    </For>
                  </tbody>
                </table>
              </div>
            </Show>

          </>
        );
      })()}
    </Show>
  );
};

export default RaceCard;
